<template>
<div class="chapter">
<div class="inner_page">
<nav epub:type="toc"><h2>Contents</h2>
<ol class="bbb-rw" epub:type="list"><li><a href="#/cover">Cover</a></li>
<li><a href="#/s001BookTitlePage01">Title Page</a></li>
<li><a href="#/s002Copyright01">Copyright</a></li>
<li><a href="#/s004Dedication01">Dedication</a></li>
<li><a href="#/s005Epigraph01">Epigraph</a></li>
<li>
<a href="#/s006Part001">one</a>
<ol epub:type="list"><li><a href="#/s007Chapter001">Aiden</a></li>
<li><a href="#/s008Chapter002">Jen</a></li>
<li><a href="#/s009Chapter003">Aiden</a></li>
<li><a href="#/s010Chapter004">Jen</a></li>
<li><a href="#/s011Chapter005">Aiden</a></li>
</ol></li>
<li>
<a href="#/s012Part002">two</a>
<ol epub:type="list"><li><a href="#/s013Chapter006">Aisling</a></li>
<li><a href="#/s014Chapter007">Tom</a></li>
<li><a href="#/s015Chapter008">Aisling</a></li>
<li><a href="#/s016Chapter009">Tom</a></li>
<li><a href="#/s017Chapter010">Aisling</a></li>
</ol></li>
<li>
<a href="#/s018Part003">three</a>
<ol epub:type="list"><li><a href="#/s019Chapter011">Jen</a></li>
<li><a href="#/s020Chapter012">Aiden</a></li>
<li><a href="#/s021Chapter013">Jen</a></li>
<li><a href="#/s022Chapter014">Aisling</a></li>
<li><a href="#/s023Chapter015">Tom</a></li>
<li><a href="#/s024Chapter016">Jen</a></li>
<li><a href="#/s025Chapter017">Aisling</a></li>
<li><a href="#/s026Chapter018">Tom</a></li>
<li><a href="#/s027Chapter019">Jen</a></li>
<li><a href="#/s028Chapter020">Tom</a></li>
<li><a href="#/s029Chapter021">Jen</a></li>
<li><a href="#/s030Chapter022">Tom</a></li>
<li><a href="#/s031Chapter023">Jen</a></li>
<li><a href="#/s032Chapter024">Tom</a></li>
<li><a href="#/s033Chapter025">Aiden</a></li>
<li><a href="#/s034Chapter026">Jen</a></li>
<li><a href="#/s035Chapter027">Aisling</a></li>
<li><a href="#/s036Chapter028">Jen</a></li>
<li><a href="#/s037Chapter029">Tom</a></li>
<li><a href="#/s038Chapter030">Aiden</a></li>
<li><a href="#/s039Chapter031">Jen</a></li>
<li><a href="#/s040Chapter032">Tom</a></li>
<li><a href="#/s041Chapter033">Aiden</a></li>
<li><a href="#/s042Chapter034">Jen</a></li>
<li><a href="#/s043Chapter035">Tom</a></li>
<li><a href="#/s044Chapter036">Jen</a></li>
<li><a href="#/s045Chapter037">Aisling</a></li>
<li><a href="#/s046Chapter038">Jen</a></li>
<li><a href="#/s047Chapter039">Tom</a></li>
<li><a href="#/s048Chapter040">Jen</a></li>
<li><a href="#/s049Chapter041">Tom</a></li>
<li><a href="#/s050Chapter042">Jen</a></li>
<li><a href="#/s051Chapter043">Tom</a></li>
<li><a href="#/s052Chapter044">Jen</a></li>
<li><a href="#/s053Chapter045">Aisling</a></li>
<li><a href="#/s054Chapter046">Jen</a></li>
</ol></li>
<li>
<a href="#/s055Part004">four</a>
<ol epub:type="list"><li><a href="#/s056Chapter047">Tom</a></li>
<li><a href="#/s057Chapter048">Jen</a></li>
<li><a href="#/s058Chapter049">Sinai</a></li>
<li><a href="#/s059Chapter050">Aisling</a></li>
<li><a href="#/s060Chapter051">Jen</a></li>
<li><a href="#/s061Chapter052">Tom</a></li>
<li><a href="#/s062Chapter053">Sinai</a></li>
<li><a href="#/s063Chapter054">Aiden</a></li>
<li><a href="#/s064Chapter055">Sinai</a></li>
<li><a href="#/s065Chapter056">Tom</a></li>
<li><a href="#/s066Chapter057">Aisling</a></li>
<li><a href="#/s067Chapter058">Jen</a></li>
<li><a href="#/s068Chapter059">Sinai</a></li>
<li><a href="#/s069Chapter060">Aiden</a></li>
<li><a href="#/s070Chapter061">Tom</a></li>
</ol></li>
<li>
<a href="#/s071Part005">five</a>
<ol epub:type="list"><li><a href="#/s072Chapter062">Jen</a></li>
<li><a href="#/s073Chapter063">Aiden</a></li>
<li><a href="#/s074Chapter064">Jen</a></li>
<li><a href="#/s075Chapter065">Sinai</a></li>
<li><a href="#/s076Chapter066">Aiden</a></li>
<li><a href="#/s077Chapter067">Jen</a></li>
<li><a href="#/s078Chapter068">Tom</a></li>
</ol></li>
<li>
<a href="#/s079Part006">six</a>
<ol epub:type="list"><li><a href="#/s080Chapter069">Jen</a></li>
<li><a href="#/s081Chapter070">Sinai</a></li>
<li><a href="#/s082Chapter071">Jen</a></li>
<li><a href="#/s083Chapter072">Aisling</a></li>
<li><a href="#/s084Chapter073">Jen</a></li>
<li><a href="#/s085Chapter074">Sinai</a></li>
<li><a href="#/s086Chapter075">Aiden</a></li>
</ol></li>
<li>
<a href="#/s087Part007">seven</a>
<ol epub:type="list"><li><a href="#/s088Chapter076">Tom</a></li>
<li><a href="#/s089Chapter077">Sinai</a></li>
<li><a href="#/s090Chapter078">Jen</a></li>
<li><a href="#/s091Chapter079">Aisling</a></li>
<li><a href="#/s092Chapter080">Jen</a></li>
<li><a href="#/s093Chapter081">Aiden</a></li>
<li><a href="#/s094Chapter082">Jen</a></li>
</ol></li>
<li>
<a href="#/s095Part008">eight</a>
<ol epub:type="list"><li><a href="#/s096Chapter083">Jen</a></li>
<li><a href="#/s097Chapter084">Sinai</a></li>
<li><a href="#/s098Chapter085">Tom</a></li>
<li><a href="#/s099Chapter086">Sinai</a></li>
<li><a href="#/s100Chapter087">Jen</a></li>
<li><a href="#/s101Chapter088">Sinai</a></li>
<li><a href="#/s102Chapter089">Ingrid</a></li>
<li><a href="#/s103Chapter090">Jen</a></li>
<li><a href="#/s104Chapter091">Sinai</a></li>
<li><a href="#/s105Chapter092">Jen</a></li>
<li><a href="#/s106Chapter093">Sinai</a></li>
<li><a href="#/s107Chapter094">Jen</a></li>
<li><a href="#/s108Chapter095">Sinai</a></li>
<li><a href="#/s109Chapter096">Tom</a></li>
<li><a href="#/s110Chapter097">Jen</a></li>
<li><a href="#/s111Chapter098">Colm</a></li>
<li><a href="#/s112Chapter099">Sinai</a></li>
<li><a href="#/s113Chapter100">Jen</a></li>
<li><a href="#/s114Chapter101">Tom</a></li>
<li><a href="#/s115Chapter102">Aisling</a></li>
<li><a href="#/s116Chapter103">Sinai</a></li>
<li><a href="#/s117Chapter104">Jen</a></li>
<li><a href="#/s118Chapter105">Tom</a></li>
<li><a href="#/s119Chapter106">Colm</a></li>
<li><a href="#/s120Chapter107">Steeve</a></li>
<li><a href="#/s121Chapter108">Jen</a></li>
</ol></li>
<li>
<a href="#/s122Part009">nine</a>
<ol epub:type="list"><li><a href="#/s123Chapter109">Jen</a></li>
<li><a href="#/s124Chapter110">Tom</a></li>
<li><a href="#/s125Chapter111">Jen</a></li>
<li><a href="#/s126Chapter112">Sinai</a></li>
<li><a href="#/s127Chapter113">Aisling</a></li>
<li><a href="#/s128Chapter114">Jen</a></li>
</ol></li>
<li><a href="#/s129Acknowledgements01">Acknowledgments</a></li>
<li id="toc-discover"><a href="#/discoverpage">Discover More</a></li>
<li><a href="#/s130AboutTheAuthor01">About the Author</a></li>
</ol></nav>
<nav class="ccc-rw" epub:type="landmarks"><h2>
    Navigation
   </h2>
<ol epub:type="list"><li>
<a epub:type="bodymatter" href="#/s006Part001#Part1">
      Begin Reading
     </a>
</li>
<li>
<a epub:type="toc" href="#/TOC">
      Table of Contents
     </a>
</li>
</ol></nav>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// TOC.vue?0241a9be